import React, {ReactNode} from "react"

import {PerkRedemptionsReport} from "@irati/types"
import FormatMessage from "@irati/utils/lang"
import {H6} from "@irati/ui/src/Typography"
import mainTheme from "@irati/ui/src/global/theme"
import {IconTypes} from "@irati/ui/src/Icon"
import Badge from "@irati/ui/src/Badge"

import {PopularPerks} from "../../../Renderers"
import {Label, Icon} from "./styled"
import getTotalSavings from "./getTotalSavings"

const FLEXI_PERK = "flexi_perk"

const columns = (formatMessage: FormatMessage, selectedCurrency: string) => [
  {
    Header: <Label large>{formatMessage({id: "admin.reporting.popularPerks.perk"})}</Label>,
    accessor: "header",
    minWidth: 450,
    style: {border: "none"},
    Cell: (props): ReactNode => <PopularPerks
      {...props}
      headerAccessor="_original.header"
      logoUrl="_original.thumbnailImage"
      brandName="_original.brandName" />
  },
  {
    Header: <Label large>{formatMessage({id: "admin.reporting.popularPerks.type"})}</Label>,
    id: "type",
    accessor: ({type}: PerkRedemptionsReport) => <Badge
      bgColor={mainTheme.colors.greys.light}
      color={mainTheme.colors.greys.black}>
      {type === FLEXI_PERK && <Icon icon={IconTypes.flexiPoints} size={16} marginRight />}
      <Label>{type.replace("_", " ")}</Label>
    </Badge>,
    minWidth: 180,
    style: {alignSelf: "center", border: "none"}
  },
  {
    Header: <Label large>{formatMessage({id: "admin.reporting.popularPerks.totalRedemptions"})}</Label>,
    id: "redemption_count",
    accessor: ({redemptions}: PerkRedemptionsReport) => <H6>{redemptions}</H6>,
    minWidth: 230,
    style: {alignSelf: "center", border: "none"}
  },
  {
    Header: <Label large>{formatMessage({id: "admin.reporting.popularPerks.users"})}</Label>,
    id: "uniqueUsers",
    minWidth: 175,
    style: {alignSelf: "center", border: "none"},
    accessor: ({uniqueUsers}: PerkRedemptionsReport) => <H6>{uniqueUsers}</H6>
  },
  {
    Header: <Label large>{formatMessage({id: "admin.reporting.popularPerks.totalSavings"})}</Label>,
    id: "totalSavings",
    minWidth: 170,
    style: {alignSelf: "center", border: "none"},
    accessor: (props: PerkRedemptionsReport) => {
      return <H6>{getTotalSavings(props, selectedCurrency, true)}</H6>
    }
  }
]
export default columns
